import React, { useState } from "react";
import "./Step.css";

const Step = (props) => {
  const [leftValue, setLeftValue] = useState(null);

  const { status } = props;

  // enable when the plan is not in Processing, Submitted or Error
  let firstProcessDone =
    status === "verify" ||
    status === "verifying" ||
    status === "submitted_for_verification" ||
    status === "verified" ||
    status === "discarded";

  // enable when re processing is successful
  let secondProcessDone = status === "verified";

  const mouseOverEvent = (e) => {
    setLeftValue(e.pageX - 35);
  };

  return (
    <div className="circle-container">
      <div
        onMouseOver={mouseOverEvent}
        className={`circle1 ${firstProcessDone ? "circle-number-enable" : ""}`}
      >
        1
      </div>
      <div className="circle-line" />
      <div
        onMouseOver={mouseOverEvent}
        className={`circle2 ${secondProcessDone ? "circle-number-enable" : ""}`}
      >
        2
      </div>
      <div style={{ left: leftValue }} className="step-hover-content">
        <div className="status-header-container">
          <div
            className={`status-circle ${
              firstProcessDone ? "status-circle-enable" : ""
            }`}
          >
            1
          </div>
          <div
            className={
              firstProcessDone ? "status-header" : "status-header-disable"
            }
          >
            Verify
          </div>
        </div>
        <div className="status-text-line status-text">
          Verify AI result and finish reviewing plan for all applicable codebook
          requirements
        </div>
        <div className="status-header-container">
          <div
            className={`status-circle ${
              secondProcessDone ? "status-circle-enable" : ""
            }`}
          >
            2
          </div>
          <div
            className={
              secondProcessDone ? "status-header" : "status-header-disable"
            }
          >
            Download
          </div>
        </div>
        <div className="status-text">
          Download output documents such as comments letter and Verified plan
          document.
        </div>
      </div>
    </div>
  );
};

export default Step;
